import { Text } from "@growtherapy/sprout-ui";
import { faCircleMinus, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { ModifiedToastAria, Toast, ToastVariant } from "../../toasts";

const CLIENT_CONSENT_COPY = [
  "Your client has consented.",
  "Transcription is in progress.",
] as const;
const CLIENT_DID_NOT_CONSENT_COPY = [
  "Your client does not consent to transcription.",
  "Your session will not be transcribed.",
] as const;

export function ClientTranscriptionConsentToast({
  contentProps,
  descriptionProps,
  isOptIn,
  titleProps,
  ...toastAriaProps
}: ModifiedToastAria & { isOptIn: boolean }) {
  const [titleCopy, descriptionCopy] = isOptIn
    ? CLIENT_CONSENT_COPY
    : CLIENT_DID_NOT_CONSENT_COPY;

  return (
    <Toast
      {...toastAriaProps}
      variant={isOptIn ? ToastVariant.Success : ToastVariant.Info}
      icon={isOptIn ? faCheckCircle : faCircleMinus}
    >
      <div {...contentProps}>
        <Text as="span" {...titleProps}>
          {titleCopy}{" "}
        </Text>
        <Text as="span" {...descriptionProps}>
          {descriptionCopy}
        </Text>
      </div>
    </Toast>
  );
}
